// @ts-check
import React, { useEffect, useState } from "react";
import { Col, Container } from "react-bootstrap";
import {
  uploadKycDocuments,
  getKycDocuments,
} from "../../../../redux/user/actions";
import {
  APP_CONST,
  INPUT_TYPE,
  KYC_DOC_TYPES,
  MaxFileSize,
} from "../../../../config/const";
import LeftArrow from "../../../../assets/images/icons/back.png";
import { Toaster } from "../../../../utils/toaster";
import KycForm from "../../../components/kyc/kycForm";
import KycList from "../../../components/kyc/KycList";
import { useNavigate } from "react-router-dom";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import LeftBarSports from "../../../components/LeftBarSports";
import Footer from "../../../../containers/Footer";

/**
 *
 * @typedef{{
 * expiry:string | null;
 * documentFileFront:string | null
 * documentFileBack : string | null
 * }} T_formError
 */

const KycModule = () => {
  /**
   * @type {[T_formError | {},React.Dispatch<React.SetStateAction<T_formError | {}>>]}
   */
  const [formError, setFormError] = useState({});
  const [formData, setFormData] = useState({});
  const [kycDocuments, setKycDocuments] = useState([]);
  const [selectedDocType, setSelectedDocType] = useState(KYC_DOC_TYPES[0]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    loadKycDoc();
  }, []);

  // Get kyc docs
  const loadKycDoc = async () => {
    const response = await getKycDocuments();
    if (response) {
      setKycDocuments(response?.data?.data);
    }
  };

  // handle Change
  /**
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event
   * @param {string} inputType
   */

  const handleChange = (event, inputType = INPUT_TYPE.TEXT) => {
    const name = event.target.name;
    const value =
      inputType === INPUT_TYPE.TEXT || inputType === INPUT_TYPE.DATE
        ? event.target.value
        : event.target.files?.[0];
    // 2024-08-05 05:37:57
    const form = {
      ...formData,
      [name]: value,
    };

    validateData(form);
    setFormData(form);
  };

  /**
   *
   * @param {object} realTimeValue
   * @returns {object}
   */

  //Validate form data
  const validateData = (realTimeValue = formData) => {
    const newErrors = {};
    /**
     * @type {any}
     */
    const { expiry, documentFileFront, documentFileBack } = realTimeValue;

    if (!Boolean(documentFileFront)) {
      newErrors.documentFileFront = "Front side file is mandatory";
    } else if (documentFileFront?.size > MaxFileSize) {
      newErrors.documentFileFront = `Max allowed file size is ${
        MaxFileSize / 1000000
      } MB`;
    }

    if (
      selectedDocType.requiredBackSide === true &&
      !Boolean(documentFileBack)
    ) {
      newErrors.documentFileBack = `Back side file is mandatory for ${selectedDocType.name}`;
    } else if (documentFileBack?.size > MaxFileSize) {
      newErrors.documentFileBack = `Max allowed file size is ${
        MaxFileSize / 1000000
      } MB`;
    }
    if (!expiry) {
      newErrors.expiry = "Expiry cannot be empty";
    }

    setFormError(newErrors);
    return newErrors;
  };

  // handle kyc upload
  const handleSubmit = async () => {
    if (Object.values(validateData()).length === 0) {
      // Uplaod kyc docs
      setIsLoading(true);
      const response = await uploadKycDocuments({
        ...formData,
        type: selectedDocType.key,
      });
      setIsLoading(false);
      if (response) {
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Kyc document uploaded");
        loadKycDoc();
      }
    }
  };

  return (
    <>
      <HeaderAfterLogin />
      <main className="main">
        <div className="main-page">
          <LeftBarSports />
          <div className="main-content">
            <Container>
              <div className="inner-wrapper">
                <div className="right-content-wrapper">
                  <div className="headingSec">
                    <div className="back-link" onClick={() => navigate(-1)}>
                      <img src={LeftArrow} alt="LeftArrow" /> <h1>KYC</h1>
                    </div>
                  </div>

                  <div className="KycSection">
                    <KycForm
                      handleChange={handleChange}
                      formError={formError}
                      selectedDocType={selectedDocType}
                      setSelectedDocType={setSelectedDocType}
                    />
                    <Col xs={12} className="text-center mt-2">
                      <button
                        className="btn btn-primary py-2 px-5"
                        onClick={handleSubmit}
                        disabled={isLoading}
                      >
                        {isLoading ? "Submitting" : "Submit"}
                      </button>
                    </Col>
                  </div>
                  {/* List kyc documents */}
                  <KycList kycDocuments={kycDocuments} />
                </div>
              </div>
            </Container>
            <Footer />
          </div>
        </div>
      </main>
    </>
  );
};

export default KycModule;
